import { SuperbetRouteConfig } from '@superbet-group/web.types';

import { Product } from '@app/router/products/Product';
import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { Title } from '@app/router/constants/Title';
import { defaultLayout } from '@app/router/utils';
import { PE130Page } from '@pages/PE130Page';

export const popularBetsRoutes: SuperbetRouteConfig[] = [
    {
        path: Link.Sport.PopularBets,
        name: RouteName.Sport.PopularBets,
        isAccessible: Product.Sport,
        components: {
            ...defaultLayout,
            ...PE130Page,
        },
        meta: {
            title: Title.Sport.PopularBets,
            layoutClass: 'sport-page',
            headerTitle: 'Popular Bets',
        },
    },
];
